// extracted by mini-css-extract-plugin
export var actionButton = "_fv-t";
export var buttonContainer = "_fv-0";
export var buttonContainer2 = "_fv-1";
export var buttonSection = "_fv-2";
export var details = "_fv-3";
export var dropdownItem = "_fv-5";
export var dropdownItemsContainer = "_fv-4";
export var fileInput = "_fv-r";
export var headerButton = "_fv-6";
export var icon = "_fv-7";
export var input = "_fv-8";
export var macroListItem = "_fv-9";
export var mainContent = "_fv-a";
export var microText = "_fv-b";
export var modal = "_fv-w";
export var optionsButton = "_fv-c";
export var paperclip = "_fv-s";
export var pillContent = "_fv-d";
export var preview = "_fv-e";
export var preview2 = "_fv-f";
export var quillEditor = "_fv-q";
export var selectedMacro = "_fv-g";
export var sidebar = "_fv-h";
export var sidebarHeader = "_fv-j";
export var sidebarList = "_fv-i";
export var sidebarListItem = "_fv-k";
export var sidebarSearch = "_fv-l";
export var snoozeDurationWrapper = "_fv-v";
export var statusPillContainer = "_fv-m";
export var tagsContainer = "_fv-n";
export var unselectedMacro = "_fv-o";
export var variable = "_fv-u";
export var wrapper = "_fv-p";